import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface AddAccountApiParameter extends ApiParameter {
    account: Partial<AddAccountModelExtended>;
}

export interface AddAccountModelExtended extends AccountModel {
    epaAttachment: any;
    rescaleAttachment: any;
    tdrlAttachment: any;
}

const customAddAccountUrl = "/api/v2/accounts/addaccount";
export async function addAccountService(parameter: AddAccountApiParameter): Promise<ServiceResult<AccountModel>> {
    const params = parameter.account as AddAccountModelExtended;
    const formData = new FormData();

    for (const [key, value] of Object.entries(params.properties || "")) {
        formData.append(key, value);
    }

    formData.append("FirstName", params.firstName || "");
    formData.append("LastName", params.lastName || "");
    formData.append("Password", params.password || "");
    formData.append("UserName", params.userName || "");
    formData.append("IsSubscribed", JSON.stringify(params.isSubscribed));
    formData.append("IsGuest", JSON.stringify(false));
    formData.append("Email", params.email || "");
    formData.append("RequiresActivation", JSON.stringify(params.requiresActivation) || "");
    if (params.epaAttachment !== null && params.epaAttachment !== "") {
        formData.append("epaAttachment", params.epaAttachment);
    }
    if (params.rescaleAttachment !== null && params.rescaleAttachment !== "") {
        formData.append("rescaleAttachment", params.rescaleAttachment);
    }
    if (params.tdrlAttachment !== null && params.tdrlAttachment !== "") {
        formData.append("tdrlAttachment", params.tdrlAttachment);
    }

    try {
        const accountModel = await request<ServiceResult<AccountModel>>(customAddAccountUrl, "POST", {}, formData);
        return {
            result: (accountModel as unknown as any).result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status
            };
        }

        throw error;
    }
}
